var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mt-10"},[_c('span',{staticClass:"px-5 pill-danger pulse-danger"},[_vm._v("Sanbox")]),_c('vx-card',{staticClass:"mt-5",attrs:{"title":"Reclamaciones"}},[_c('claims-form')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }